import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Cppsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cswitch(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      
       <Sides/>
       <Helmet>
 
 <title>Switch in C++ tutorial For Beginners</title>
 <meta name="description" content="Switch in C++ tutorial for beginners.switch case in c++ used in multiple conditions having different statements like-if else if,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,Switch in C++ tutorial for beginners,programming language,tutorial for begineers,learn code in free,c++ programming tutorial for beginners,learn code in free online,switch case in cpp,c++ case statement,cpp switch statement,c++ switch case,c++ switch case example,cpp switch on string,cpp switch string,c++ programming switch statement,c++ programming switch case,cpp switch example,c++ switch default,switch c++ language,c++ switch case string,cpp switch statement string,cpp language switch case" />
 <link rel="canonical" href="https://www.codeexampler.com/cpp-switch" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">Switch Statement in C++ Programming</h1>
    <div className="first">
        <a href="/cpp-if-else-if">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-looping">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">What is Switch Statement in C++:</h2>
    <p className="mt-4 para">A switch case in C++ is used in multiple conditions with different statements like-if if, but it can check only equality of the condition floating point, but the switch can’t check value.</p>

<h2 className='headings'>The syntax for Switch statement C++:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            
          <span className="qwerty-5">switch </span>
            <span className="qwerty-3">(</span>
              <span className="qwerty-10">variable</span>
            <span className="qwerty-3">)</span>
            {"\n"}{"\n"}
            
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">case </span>
            <span className="qwerty-10">1</span>
            <span className="qwerty-3">:</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-7">Statement </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">case </span>
            <span className="qwerty-10">2</span>
            <span className="qwerty-3">:</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-4">Statement </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-10">Default</span>
            <span className="qwerty-3">:</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-7">Statement </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          
          </code>
        </pre>
      </div>


<p className="mt-4 para">In this keyword switch inside c++ programming  that will yield an integer value, For Example-case1,case2, etc this is an integer constant<br/>
if you do not find any match in this case statements so on that time default statement is executed and Check <a href="https://www.codeexampler.com/cpp-break">c++ break Statement</a> 
</p>
   

   
<h2 className='headings'>Q-Write a program to input a no and print month name and if no is two but without a Break?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-11">int</span>
            <span className="qwerty-10"> i</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">Enter a number</span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-11">cin </span>
            <span className="qwerty-3">&#62;&#62;</span>
            <span className="qwerty-10"> i</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">switch </span>
            <span className="qwerty-3">(</span>
              <span className="qwerty-10">i</span>
            <span className="qwerty-3">)</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">case </span>
            <span className="qwerty-10">1</span>
            <span className="qwerty-3">:</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">Jan \n</span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">case </span>
            <span className="qwerty-10">2</span>
            <span className="qwerty-3">:</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">Feb \n</span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">case </span>
            <span className="qwerty-10">3</span>
            <span className="qwerty-3">:</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">Mar \n</span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">case </span>
            <span className="qwerty-10">4</span>
            <span className="qwerty-3">:</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">Apr \n</span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">case </span>
            <span className="qwerty-10">5</span>
            <span className="qwerty-3">:</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">May \n</span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">default</span>
            <span className="qwerty-3">:</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10"> Check No </span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">return </span>
            <span className="qwerty-10">0 </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
              {"\n"}
              <span className="qwerty-5">enter a number </span>
              <span className="qwerty-10">2</span>
              {"\n"}{"\n"}{" "} 
              <span className="qwerty-10">Feb </span>
              {"\n"}{"\n"}{" "} 
              <span className="qwerty-10">Mar </span>
              {"\n"}{"\n"}{" "} 
              <span className="qwerty-10">Apr </span>
              {"\n"}{"\n"}{" "} 
              <span className="qwerty-10">May </span>
              {"\n"}{"\n"}{" "} 
              <span className="qwerty-5">Check No</span>
         
              {"\n"}{" "}
              {"\n"}</code></pre>
        </div>
      </div>



   <p className="mt-4 para">This program gives output but is not expecting because we did not provide case 3 and the default value.</p>
<h2 className="mt-4 mh2"> Break switch statement:</h2>
<p className="mt-4 para">If you want to give the only <span className="bold"> case 2</span>statement so using break statement</p>

   

   

<h2 className='headings'>Q-Write a program to input a no and print month name, and if no is two, use a break?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-11">int</span>
            <span className="qwerty-10"> i</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">Enter a number</span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-11">cin </span>
            <span className="qwerty-3">&#62;&#62;</span>
            <span className="qwerty-10"> i</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-5">switch </span>
            <span className="qwerty-3">(</span>
              <span className="qwerty-10">i</span>
            <span className="qwerty-3">)</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-5">case </span>
            <span className="qwerty-10">1</span>
            <span className="qwerty-3">:</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">Jan \n</span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-11">break</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-5">case </span>
            <span className="qwerty-10">2</span>
            <span className="qwerty-3">:</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">Feb \n</span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-11">break</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-5">case </span>
            <span className="qwerty-10">3</span>
            <span className="qwerty-3">:</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">Mar \n</span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-11">break</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-5">case </span>
            <span className="qwerty-10">4</span>
            <span className="qwerty-3">:</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">Apr \n</span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-11">break</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-5">case </span>
            <span className="qwerty-10">5</span>
            <span className="qwerty-3">:</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">May \n</span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-11">break</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-5">default</span>
            <span className="qwerty-3">:</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10"> Check No </span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">return </span>
            <span className="qwerty-10">0 </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
              {"\n"}
              <span className="qwerty-5">enter a number </span>
              <span className="qwerty-10">2</span>
              {"\n"}{"\n"}{" "} 
              <span className="qwerty-10">Feb </span>
             
         
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>



   

<h2 className='headings'>Q-write a program without user input switch case char?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-11">int</span>
            <span className="qwerty-10"> i</span>
            <span className="qwerty-3"> =</span>
            <span className="qwerty-10"> 20</span>
            <span className="qwerty-3"> ;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">switch </span>
            <span className="qwerty-3">(</span>
              <span className="qwerty-10">i</span>
            <span className="qwerty-3">)</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">case </span>
            <span className="qwerty-10">10</span>
            <span className="qwerty-3">:</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">My case is 10 \n</span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-11">break</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-5">case </span>
            <span className="qwerty-10">20</span>
            <span className="qwerty-3">:</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">My case is 20 \n</span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-11">break</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-5">case </span>
            <span className="qwerty-10">30</span>
            <span className="qwerty-3">:</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">My case is 30 \n</span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-11">break</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-5">case </span>
            <span className="qwerty-10">40</span>
            <span className="qwerty-3">:</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">My case is 40 \n</span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-11">break</span>
            <span className="qwerty-3">; </span>
            <span className="qwerty-5">case </span>
            <span className="qwerty-10">50</span>
            <span className="qwerty-3">:</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">My case is 50 \n</span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-11">break</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">default</span>
            <span className="qwerty-3">:</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10"> Check No </span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">return </span>
            <span className="qwerty-10">0 </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
              {"\n"}
              <span className="qwerty-5">My case is </span>
              <span className="qwerty-10">20</span>
           
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>



<h2 className="m-4">Char values in switch case:
</h2>


<h2 className='headings'>Q-write a program without input use switch case char?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-11">char</span>
            <span className="qwerty-10"> x</span>
            <span className="qwerty-3">='</span>
            <span className="qwerty-10">c</span>
            <span className="qwerty-3">';</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">switch </span>
            <span className="qwerty-3">(</span>
              <span className="qwerty-10">x</span>
            <span className="qwerty-3">)</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">case </span>
            <span className="qwerty-10">10</span>
            <span className="qwerty-3">:</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">My case is a\n</span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-11">break</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">case </span>
            <span className="qwerty-10">20</span>
            <span className="qwerty-3">:</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">My case is b\n</span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-11">break</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            
            <span className="qwerty-5">case </span>
            <span className="qwerty-10">30</span>
            <span className="qwerty-3">:</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">My case is c\n</span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-11">break</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            
            <span className="qwerty-5">case </span>
            <span className="qwerty-10">40</span>
            <span className="qwerty-3">:</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">My case is d\n</span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-11">break</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}

            <span className="qwerty-5">case </span>
            <span className="qwerty-10">50</span>
            <span className="qwerty-3">:</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10">My case is e\n</span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-11">break</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">default</span>
            <span className="qwerty-3">:</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10"> Check No </span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">return </span>
            <span className="qwerty-10">0 </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
              {"\n"}
              <span className="qwerty-5">case </span>
              <span className="qwerty-10">c</span>

              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>


<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/cpp-if-else-if">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-looping">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div>
    </div>
)

}
export default Cswitch;